<template>
  <div class="to_processed container_width whiteborder">
    <div class="processed_title">
      举报详情
      <!-- <span v-if="isShow" class="show_status">待处理</span>
      <span v-else class="processed_status">已处理</span>-->
      <el-tag :type="dataMap[status][0]">{{dataMap[status][1]}}</el-tag>
    </div>
    <ul class="data_detail">
      <li v-for="(item,index) of ToProcessedData" :key="index">
        <span class="category">{{item.category}}：</span>
        <span class="data_infor">{{item.dataInfor}}</span>
      </li>
      <li v-if="materialData.length">
        <span class="category">举报材料：</span>
        <div class="reporting_material">
          <div class="data_detaillist" v-for="(item,index) of materialData" :key="index">
            <span class="data_detail_name">{{item}}</span>
            <!-- <span class="download_icon el-icon-bottom" @click="aloneDownload(index)"></span> -->
          </div>
          <!-- <div class="all_download" @click="allDownload">全部下载</div> -->
        </div>
      </li>
    </ul>
    <!-- <div class="deal_with">
      <span class="button_style cancel" @click="goBack">取消</span>
      <span class="button_style asubmit" @click="toDeal">开始处理</span>
    </div> -->
  </div>
</template>

<script>
import { reportDetail, downReport } from "common/js/api";
import { mapMutations } from "vuex";
const map = {
  1: ["info", "待处理"],
  2: ["success", "已受理"],
  3: ["danger", "已驳回"]
};

export default {
  name: "ToProcessed",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id: this.$route.query.id,
      companyName: this.$route.query.companyName,
      status: this.$route.query.status,
      ToProcessedData: [
        {
          category: "举报编号",
          dataInfor: ""
        },
        {
          category: "举报时间",
          dataInfor: ""
        },
        {
          category: "举报机构",
          dataInfor: ""
        },
        {
          category: "事项及理由",
          dataInfor: ""
        },
        {
          category: "举报联系人",
          dataInfor: ""
        },
        {
          category: "身份证号",
          dataInfor: ""
        },
        {
          category: "联系电话",
          dataInfor: ""
        }
      ],
      materialData: [],
      dataMap: map
    };
  },

  created() {
    this.getDetail();
  },

  methods: {
    async getDetail() {
      this.changeLoadingstate(true);
      const { result } = await reportDetail( this.id );
      this.ToProcessedData[0].dataInfor = result.serialNumber;
      this.ToProcessedData[1].dataInfor = result.createdTime;
      this.ToProcessedData[2].dataInfor = result.agencyName;
      this.ToProcessedData[3].dataInfor = result.reportReason;
      this.ToProcessedData[4].dataInfor = result.reportName;
      this.ToProcessedData[5].dataInfor = result.reportIdNumber;
      this.ToProcessedData[6].dataInfor = result.reportPhone;
      this.materialData = result.reportFileUrls || [];
    },

    goBack() {
      //   this.$router.go("-1");
    },

    toDeal() {
      this.$router.push({
        path: "/ReportPlatform/Processing",
        query: {
          id: this.id,
          companyName: this.companyName
        }
      });
    },

    allDownload() {
      for (let i = 0; i < this.materialData.length; i++) {
        this.aloneDownload(i);
      }
    },

    async aloneDownload(index) {
      await downReport(this.id, index, 0);
    },

    ...mapMutations(["changeLoadingstate"])
  }
};
</script>

<style scoped>
.processed_title {
  font-size: 28px;
  color: #0f1824;
  font-weight: bold;
}
.processed_title span {
  margin-left: 10px;
  font-weight: normal;
  vertical-align: top;
  display: inline-block;
  width: 62px;
  height: 24px;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  border-radius: 2px;
}
.show_status {
  color: #3165ff;
  background: #dde6ff;
}
.processed_status {
  background: #e9f6e0;
  color: #75c139;
}
.data_detail {
  margin-top: 20px;
}
.category {
  font-size: 14px;
  font-weight: bold;
  color: #0f1824;
  /* vertical-align: top; */
}
.data_infor {
  font-size: 14px;
  color: #6c7885;
  line-height: 20px;
}
.data_detail li {
  margin-bottom: 20px;
}
.reporting_material {
  width: calc(100% - 80px);
  display: inline-block;
}
.button_style,
.all_download {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 100px;
  height: 28px;
  line-height: 28px;
}
.deal_with {
  margin-top: 40px;
}
.cancel,
.all_download {
  border: 1px solid #dddddd;
  border-radius: 2px;
  margin-right: 16px;
}
.all_download {
  font-size: 14px;
  color: #3165ff;
  border: 1px solid #3165ff;
  border-radius: 2px;
  margin-top: 35px;
}
.asubmit {
  background: #3165ff;
  border-radius: 2px;
  color: #fff;
}
.data_detaillist {
  position: relative;
  background: #f3f3f3;
  border-radius: 2px;
  padding: 3px;
  margin-bottom: 2px;
  padding: 5px 8px;
  width: 100%;
  /* max-width: 678px; */
}
.download_icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  color: #fff;
  font-size: 12px;
  width: 16px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  background: #fb5353;
}
.data_detail_name {
  font-size: 14px;
  color: #3165ff;
}
</style>
